import MyClientTable from "./MyClientTable.jsx";

export default MyClientTable;



// WEBPACK FOOTER //
// ./src/components/pages/MyClients/myClientTable/index.js